export const TEMPLATES_RESET_STATE = 'RECEIPTS_RESET_STATE';
export const TEMPLATES_CURRENT_ITEM = 'RECEIPTS_CURRENT_ITEM';

export const TEMPLATES_REQUEST_LOADING = 'RECEIPTS_REQUEST_LOADING';
export const TEMPLATES_REQUEST_SUCCESS = 'RECEIPTS_REQUEST_SUCCESS';
export const TEMPLATES_REQUEST_FAILED = 'RECEIPTS_REQUEST_FAILED';

export const TEMPLATES_CURRENT_ACTION = 'RECEIPTS_CURRENT_ACTION';
export const TEMPLATES_RESET_ACTION = 'RECEIPTS_RESET_ACTION';